export default { sha: '3ff9cf3da4b728b6acd03572079e757a3e4defaa', buildNumber: 'undefined' }
